import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQ } from "../mock/data";
import { Wrap, SectionHead, Reveal } from "./Section";

export default function Faq() {
  const cats = [...new Set(FAQ.map((f) => f.cat))];
  const [cat, setCat] = useState(cats[0]);
  const [open, setOpen] = useState(0);
  const items = FAQ.filter((f) => f.cat === cat);

  return (
    <Wrap id="faq">
      <SectionHead tag="Questions" title="The things people ask" highlight="before they decide" />

      <Reveal className="mt-10">
      <div className="flex flex-wrap gap-2">
        {cats.map((c) => (
          <button key={c} onClick={() => { setCat(c); setOpen(0); }}
            className={`label px-4 py-2.5 rounded-lg transition-colors ${cat === c ? "bg-accent text-[#0a0d08]" : "bg-white/[0.03] text-[var(--muted)] hover:text-[var(--text)] border border-white/[0.07]"}`}>
            {c}
          </button>
        ))}
      </div>

      <div className="mt-8 max-w-3xl">
        {items.map((f, i) => (
          <div key={i} className="border-b border-white/[0.08]">
            <button onClick={() => setOpen(open === i ? -1 : i)}
              className="w-full flex items-center justify-between gap-4 py-5 text-left">
              <span className="text-[15px] font-medium text-[var(--text)]">{f.q}</span>
              {open === i ? <Minus size={18} className="text-accent shrink-0" /> : <Plus size={18} className="text-[var(--muted)] shrink-0" />}
            </button>
            <div className={`overflow-hidden transition-all duration-300 ${open === i ? "max-h-60 pb-5" : "max-h-0"}`}>
              <p className="text-[14px] text-[var(--muted)] leading-relaxed">{f.a}</p>
            </div>
          </div>
        ))}
      </div>
      </Reveal>
    </Wrap>
  );
}
